module.exports = __webpack_public_path__ + "static/tides-da6e48cc8c8b233bc8553cdc545381e4.jpg";